import React, { useState } from "react";
import deleteBot from "./apis/deleteBot";
import { toast } from "react-toastify";

function DangerZone({ botId, bots, dispatch }) {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDeleteBot = async () => {
    setLoading(true);
    const res = await deleteBot(botId);
    setLoading(false);

    if (res.error) {
      toast.error(res.msg);
      return;
    }

    const remainingBots = bots?.filter((bot) => bot?.botId !== botId);
    dispatch({ type: "SET_BOTS", payload: remainingBots });
    dispatch({ type: "SET_SELECTED_BOT", payload: null });
    toast.success(res.msg);
    setConfirmationOpen(false);
  };

  return (
    <div className="mt-5 w-full rounded-xl p-5 bg-black text-slate-100">
      {/* Divider Header */}

      {/* Warning Section */}
      <div className="mt-2">
        <h3 className="text-xl font-semibold text-red-600">Delete Chatbot</h3>
        <p className="mt-1  text-slate-400">
          Deleting this chatbot is a permanent action and cannot be undone.
          <br />
          Please review your decision carefully before proceeding.
        </p>
        <div className="flex justify-end mt-4">
          <button
            onClick={() => setConfirmationOpen(true)}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md font-medium transition">
            Delete Chatbot
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {confirmationOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
            <h2
              id="modal-title"
              className="text-lg font-semibold text-gray-800">
              Confirm Deletion
            </h2>
            <p className=" text-gray-600 mt-2">
              Are you sure you want to delete your chatbot? This action cannot
              be undone.
            </p>
            <div className="mt-4 flex justify-end space-x-2">
              <button
                onClick={() => setConfirmationOpen(false)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded transition">
                Cancel
              </button>
              <button
                onClick={handleDeleteBot}
                disabled={loading}
                className={`px-4 py-2 rounded transition text-white ${
                  loading
                    ? "bg-red-300 cursor-not-allowed"
                    : "bg-red-500 hover:bg-red-600"
                }`}>
                {loading ? "Deleting..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DangerZone;
